import React from "react";
import { useNavigate } from "react-router-dom";

const CountBoxCard = (props) => {
  const navigate = useNavigate();
  const { navigateLink = "", label, count = 0 } = props;
  return (
    <div className="card">
      <div className="card-body">
        <div className="chart-widget-dashboard">
          <div className="media">
            <a
              className="media-body"
              style={{ cursor: "pointer" }}
              onClick={() => (navigateLink ? navigate(navigateLink) : {})}
            >
              <h5 className="mt-0 mb-0 f-w-600 text-center">
                <i data-feather="dollar-sign" />
                <span className="counter text-center">{label}</span>
              </h5>
              <h5 className="dashboard-count text-center">
                {count > 0 ? count : "00"}
              </h5>
            </a>
            <i data-feather="tag" />
          </div>
          <div className="dashboard-chart-container">
            <div className="small-chart-gradient-1" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountBoxCard;
